module.exports = __webpack_public_path__ + "img/tchibo-logo.bc91af6c.png";